<template>
    <div class="d-flex justify-content-center align-items-center  gap-2 flex-wrap h-100"
         :class="smaller ? 'flex-column' : 'flex-sm-column'">
        <div class=" flex-sm-grow-0"
             :class="smaller ? 'flex-grow-0' : 'flex-grow-1'">
            <div class="d-flex flex-column align-items-center">
                <template v-if="event.price || event.price2">
                    <h3 v-if="smaller" class="font-weight-bold mb-0">{{ event.price || '-' }}</h3>
                    <h2 v-else class="font-weight-bold mb-0">{{ event.price || '-' }}</h2>
                    <small class="mb-0">{{ event.price2 }}</small>
                </template>
            </div>
        </div>
        <div v-if="event.alternativeOrganizer && event.alternativeOrganizer.image" style="max-width: 80px">
            <img
                :src="event.alternativeOrganizer.image"
                :alt="event.alternativeOrganizer.name"
                class="img-fit">
        </div>
        <small v-else-if="event.alternativeOrganizer" class="text-center">
            {{ event.alternativeOrganizer.name }}
        </small>
        <div v-else-if="event.organizer && event.organizer.image" style="max-width: 80px">
            <img
                :src="event.organizer.image"
                :alt="event.organizer.name"
                class="img-fit">
        </div>
        <small class="text-center" v-else-if="event.organizer">
            {{ event.organizer.name }}
        </small>
    </div>
</template>

<script>
export default {
    name: "EventEntryPriceAndOrganizerInfo",
    props: {
        event: {
            type: Object,
            required: true
        },
        smaller: {
            type: Boolean
        }
    },
}
</script>

<style lang="scss" scoped>
.img-fit {
    width: 100%;
    object-fit: cover;
}
</style>
